/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcAssetsV1AssetExceptionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_ASSETS_V1_ASSET_EXCEPTION_STATE_ENTITY_NAME = 'ixc.assets.v1.AssetException';
export const ixcAssetsV1AssetExceptionStateEntity = new schema.Entity<IxcAssetsV1AssetExceptionState>(IXC_ASSETS_V1_ASSET_EXCEPTION_STATE_ENTITY_NAME, {}, { idAttribute: 'assetExceptionId' });

